import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Divider, Modal } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Grid, Button } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';
import { getperiod, minStopOptions } from '../../utils/datePeriodCalculator';
import { historyCustom } from '../../features/datacenter/datacenterApi';

import VehicleMultiSelect from '../common/VehicleMultiSelect';
import GetPeriod from '../common/GetPeriod';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
    margin: {
        margin: useTheme().spacing(1),
    },
    textField: {
        width: '25ch',
    },
    chip: {
        margin: useTheme().spacing(0.5),
    },
}));

const TrackSearchForm = ({ searchModalOpen, handleSearchModalClose }) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setlayoutLiveTracking({ mapModalHeight: 600 }));
    }, [dispatch])


    const [multiVehicles, setMultiVehicles] = useState([]);
    const [multiAssetIds, setMultiAssetIds] = useState([]);

    const [periodType, setPeriodType] = useState('today');

    const [fromDate, setFromDate] = useState(getperiod(periodType).fromDate);
    const [toDate, setToDate] = useState(getperiod(periodType).toDate);

    const [minStop, setMinStop] = useState(5);

    const [minDrive, setMinDrive] = useState(1);

    const resetForm = () => {
        setMultiVehicles([]);
        setMultiAssetIds([]);
        setPeriodType('today');
        setFromDate(getperiod('today').fromDate);
        setToDate(getperiod('today').toDate);
        setMinStop(5);
        setMinDrive(1);
    }

    const onClose = () => {
        resetForm();
        handleSearchModalClose();
    }

    const onFromDateChange = (value, ptype = "custom") => {
        //console.log("From date change", ptype);
        setFromDate(value);
        setPeriodType(ptype);
    }

    const onToDateChange = (value, ptype = "custom") => {
        //console.log("TO date change", ptype);
        setToDate(value);
        setPeriodType(ptype);
    }

    const onMinStopChange = (e) => {
        setMinStop(e.target.value);
    }

    const onMinDriveChange = (e) => {
        setMinDrive(e.target.value);
    }

    const onSearch = () => {
        let searchParam = {
            timeFrom: moment(fromDate).format('YYYY-MM-DD HH:mm:ss'),
            timeTo: moment(toDate).format('YYYY-MM-DD HH:mm:ss'),
            minStop: minStop * 60 * 1000,
            minDrive,
            trackType: 'custom',
            assets: multiVehicles,
            assetIds: multiAssetIds,
        };
        //console.log("History req", searchParam);
        dispatch(historyCustom(searchParam));
        onClose();
    }





    return (
        <Dialog
            open={searchModalOpen}
            onClose={handleSearchModalClose}
        >
            <DialogTitle><b style={{ color: 'DodgerBlue' }}>Track Form</b></DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={1} alignItems="flex-start">
                    <Grid item sm={6}>
                        <VehicleMultiSelect
                            multiVehicles={multiVehicles}
                            setMultiVehicles={setMultiVehicles}
                            multiAssetIds={multiAssetIds}
                            setMultiAssetIds={setMultiAssetIds}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <GetPeriod
                            fromDate={fromDate}
                            onFromDateChange={onFromDateChange}
                            toDate={toDate}
                            onToDateChange={onToDateChange}
                            periodType={periodType}
                        />
                    </Grid>

                    <Grid item sm={12}></Grid>

                    <Grid item sm={6}>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="minStopLabel">Minimum Stoppage Time</InputLabel>
                            <Select
                                variant="standard"
                                labelId="minStopLabel"
                                id="minStopSelect"
                                value={minStop}
                                onChange={onMinStopChange}
                            >
                                {
                                    minStopOptions.map(ev => <MenuItem key={ev.value} value={ev.value}>{ev.name}</MenuItem>)
                                }
                                <MenuItem key={"custom"} value={"custom"}>{"Custom"}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={6}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                variant="standard"
                                label="Minimum Drive Distance"
                                name="minDrive"
                                value={minDrive}
                                onChange={onMinDriveChange}
                                type="number"
                                id="standard-start-adornment"
                                className={clsx(classes.margin, classes.textField)}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">Km</InputAdornment>,
                                    step: 0.1,
                                    inputProps: {
                                        min: 0, step: 0.1,
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="secondary"
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button onClick={resetForm} variant="contained">
                    Reset Form
                </Button>
                <Button
                    onClick={onSearch}
                    variant="contained"
                >
                    Build Track
                </Button>
            </DialogActions>
        </Dialog>
    );


}

export default TrackSearchForm;